var SEL = [
  '.price-item', '.price-item--regular', '.price-item--last', '.price-item--sale',
  '[data-product-price]', '#uj-hero-price', '#uj-hero-compare', '#uj-hero-save', '.uj-save-badge',
  '.uj-stone-option', '.uj-stone-price', '[data-stone-price]', '.variant-input-wrap label',
  'fieldset.product-form__input--pill input + label',
  '.product-form__input--pill label',
  'sticky-atc .price-item', 'sticky-atc [class*="price"]',
  'select[name="id"] option', '.product-form__input select option'
,
  '.pd-stone-price-row'
].join(', ');

function strip(){
  document.querySelectorAll(SEL).forEach(function(el){
    if (!el || !el.childNodes) return;
    el.childNodes.forEach(function(n){
      if (n.nodeType === 3 && /(\$?[\d,]+)\.00\b/.test(n.nodeValue)) {
        n.nodeValue = n.nodeValue.replace(/(\$?[\d,]+)\.00\b/g, '$1');
      }
    });
    if (el.children.length === 0 && /(\$?[\d,]+)\.00\b/.test(el.textContent)) {
      el.textContent = el.textContent.replace(/(\$?[\d,]+)\.00\b/g, '$1');
    }
  });
}

function init(){
  strip();
  var obs = new MutationObserver(function(){ strip(); });
  obs.observe(document.body, {childList:true, subtree:true, characterData:true});
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
